// Stub for app/assets (stamps, user icons, etc.)
// Not used in parents app

export const stamps: any[] = [];
export const userIcons: any[] = [];

export const getAssetsByPrefix = (_prefix: string) => {
  return [];
};

export const stampCategories: string[] = [];
export const userIconPrefixes: string[] = ["assets/users/icons"];

export const stampAssets: any = {};
export const userIconAssets: any = {};
